import React, { useEffect, useState } from 'react'
import { Select, Button, Spin, Row, Col } from 'antd'
import axios from 'axios'
import AdminHeader from '../../CommonComponents/AdminHeader'
import AdminFooter from '../../CommonComponents/AdminFooter'
import {
  getChildrenList,
  GetParentInfoAndDocById,
  IMG_URL,
} from '../../APIComponents/AdminApi'

const { Option } = Select

const ParentInfoReport = () => {
  const [students, setStudents] = useState([])
  const [selectedStudent, setSelectedStudent] = useState(null)
  const [parentData, setParentData] = useState(null)
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    fetchStudents()
  }, [])

  const fetchStudents = async () => {
    try {
      const res = await axios.get(getChildrenList)
      setStudents(res.data)
    } catch (err) {
      console.error(err)
    }
  }

  const fetchParentReport = async () => {
    if (!selectedStudent) return

    setLoading(true)
    try {
      const res = await axios.get(
        `${GetParentInfoAndDocById}/${selectedStudent}`,
      )
      setParentData(res.data)
    } catch (err) {
      console.error(err)
    }
    setLoading(false)
  }

  const isPDF = (file) => {
    return file?.toLowerCase().endsWith('.pdf')
  }

  return (
    <>
      <AdminHeader />

      <div className="student-form-section container-fluid">
        <div className="student-form-wrapper pb-5">
          <div className="row student-form-title">
            <h3 className="section-title1 text-start mb-3">
              Parent Info Report
            </h3>
          </div>

          <Row gutter={16} className="mb-3 shadow rounded py-3 m-0 bg-white">
            <Col md={8}>
              <Select
                className="w-100"
                placeholder="Select Student"
                onChange={(val) => setSelectedStudent(val)}
              >
                {students.map((child) => (
                  <Option key={child.id} value={child.id}>
                    {child.fname} {child.mname} {child.lname} (Reg No:{' '}
                    {child.reg_no})
                  </Option>
                ))}
              </Select>
            </Col>

            <Col md={8}>
              <Button type="primary" onClick={fetchParentReport}>
                Show Report
              </Button>

              <Button style={{ marginLeft: 10 }} onClick={() => window.print()}>
                Print
              </Button>
            </Col>
          </Row>

          {loading ? (
            <Spin size="large" />
          ) : (
            parentData && (
              <div className="a4-page">
                {/* HEADER */}
                <div className="text-center pb-3">
                  <h2>
                    <b>सेंट क्रिस्पिन्स होम</b>
                  </h2>
                  <h5>
                    <b>पालक माहिती अहवाल</b>
                  </h5>
                </div>

                {/* PARENT INFO */}
                <div className="section">
                  <div className="row m-0 p-0">
                    <div className="col-12">
                      <p>
                        <b>विद्यार्थ्याचे नाव:</b>{' '}
                        {parentData.parentInfo?.[0]?.student?.fname}{' '}
                        {parentData.parentInfo?.[0]?.student?.mname}{' '}
                        {parentData.parentInfo?.[0]?.student?.lname}
                      </p>
                    </div>
                  </div>

                  {parentData.parentInfo?.map((p, i) => (
                    <div key={i}>
                      <div className="row p-0 m-0">
                        <div className="col-12">
                          <p>
                            <b>वडिलांचे नाव:</b> {p.father_full_name}
                          </p>
                        </div>
                        <div className="col-12">
                          <p>
                            <b>वडिलांचा व्यवसाय:</b> {p.father_occupation}
                          </p>
                        </div>
                        <div className="col-12">
                          <p>
                            <b>आईचे नाव:</b> {p.mother_full_name}
                          </p>
                        </div>
                        <div className="col-12">
                          <p>
                            <b>आईचा व्यवसाय:</b> {p.mother_occupation}
                          </p>
                        </div>
                        <div className="col-12 col-md-6">
                          <p>
                            <b>वार्षिक उत्पन्न:</b> {p.family_annual_income}
                          </p>
                        </div>
                        <div className="col-12 col-md-6">
                          <p>
                            <b>कुटुंबातील सदस्य:</b> {p.family_members}
                          </p>
                        </div>
                        <div className="col-12">
                          <p>
                            <b>पत्ता:</b> {p.address}
                          </p>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>

                {/* DOCUMENTS */}
                <div className="section">
                  <div className="row p-0 m-0">
                    {parentData.parentDoc?.map((doc, i) => (
                      <div key={i}>
                        {/* Father Document */}
                        <div className="col-12 mb-3">
                          <p>
                            <b>वडिलांचे कागदपत्रे:</b>
                          </p>

                          {doc.father_document ? (
                            Array.isArray(doc.father_document) ? (
                              doc.father_document.map((file, idx) =>
                                isPDF(file) ? (
                                  
                                  <iframe
                                    key={idx}
                                    src={`${IMG_URL}${file}`}
                                    title={`father-doc-${idx}`}
                                    className="pdf-viewer"                                    
                                  />
                                ) : (
                                  <img
                                    key={idx}
                                    src={`${IMG_URL}${file}`}
                                    className="doc-img"
                                    alt={`father-doc-${idx}`}
                                  />
                                ),
                              )
                            ) : isPDF(doc.father_document) ? (
                              <iframe
                                src={`${IMG_URL}${doc.father_document}`}
                                title="father-doc"
                                className="pdf-viewer"
                              />
                            ) : (
                              <img
                                src={`${IMG_URL}${doc.father_document}`}
                                className="doc-img"
                                alt="father-doc"
                              />
                            )
                          ) : (
                            <p>उपलब्ध नाही</p>
                          )}
                        </div>

                        {/* Mother Document */}
                        <div className="col-12 mb-3">
                          <p>
                            <b>आईचे कागदपत्रे:</b>
                          </p>

                          {doc.mother_document ? (
                            Array.isArray(doc.mother_document) ? (
                              doc.mother_document.map((file, idx) =>
                                isPDF(file) ? (
                                  <iframe
                                    key={idx}
                                    src={`${IMG_URL}${file}`}
                                    title={`mother-doc-${idx}`}
                                    className="pdf-viewer"
                                  />
                                ) : (
                                  <img
                                    key={idx}
                                    src={`${IMG_URL}${file}`}
                                    className="doc-img"
                                    alt={`mother-doc-${idx}`}
                                  />
                                ),
                              )
                            ) : isPDF(doc.mother_document) ? (
                              <iframe
                                src={`${IMG_URL}${doc.mother_document}`}
                                title="mother-doc"
                                className="pdf-viewer"
                              />
                            ) : (
                              <img
                                src={`${IMG_URL}${doc.mother_document}`}
                                className="doc-img"
                                alt="mother-doc"
                              />
                            )
                          ) : (
                            <p>उपलब्ध नाही</p>
                          )}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            )
          )}
        </div>
      </div>

      <AdminFooter />

      {/* CSS */}
      <style>{`
        .a4-page {
          width: 210mm;
          min-height: 297mm;
          padding: 20px 60px;
          background: white;
          font-family: 'Noto Sans Devanagari', sans-serif;
        }

        .section {
          margin-bottom: 20px;
        }

        .section p {
          color: black;
        }

        .text-center {
          text-align: center;
        }

        .doc-img {
          width: 100%;
          height: auto;
          max-height: 500px;
          object-fit: contain;
          margin-bottom: 15px;
          border: 1px solid black;
        }

        @media print {
          body * {
            visibility: hidden;
          }

          .a4-page, .a4-page * {
            visibility: visible;
          }

          .a4-page {
            position: absolute;
            left: 0;
            top: 0;
            width: 210mm;
          }

          .doc-img {
            page-break-inside: avoid;
            break-inside: avoid;
          }

          .section {
            page-break-inside: avoid;
          }

           /* FIX ROW */
          .row {
            display: flex !important;
            flex-wrap: wrap !important;
          }

          /*  FIX COLUMNS */
          .col-md-6 {
            width: 50% !important;
            float: left !important;
          }

          .col-md-4 {
            width: 33.33% !important;
            float: left !important;
          }

          .col-md-8 {
            width: 66.66% !important;
            float: left !important;
          }

          .col-md-12 {
            width: 100% !important;
            float: left !important;
          }

          /* remove extra spacing */
          .row > div {
            padding: 2px !important;
          }

          .certificate-img {
            page-break-inside: avoid;
            break-inside: avoid;
          }
        }
      `}</style>
    </>
  )
}

export default ParentInfoReport
